import { useState } from 'react';
import { useInvestorHoldings } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/useInvestorHoldings.ts';
import { StorageKeys } from '@dealstack/frontend/shared/helper/storageUtils.ts';
import { HoldingsSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/HoldingsSection.tsx';
import { InvestorHoldingRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/investorHoldings.types.ts';
import { HoldingTransactionsModal } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingTransactionsModal/HoldingTransactionsModal.tsx';

interface Props {
	dealId: string;
	investorId: string;
}

export const HoldingsCard = ({ dealId, investorId }: Props) => {
	const { rows, isLoading, isError } = useInvestorHoldings({ investorId });
	const [transactionsHolding, setTransactionsHolding] = useState<InvestorHoldingRow | null>(null);

	return (
		<>
			<HoldingsSection
				dealId={dealId}
				rows={rows}
				isLoading={isLoading}
				isError={isError}
				viewStorageKey={StorageKeys.MIP_INVESTOR_DETAILS_HOLDINGS_VIEW}
				onOpenTransactions={setTransactionsHolding}
			/>

			<HoldingTransactionsModal
				investorId={investorId}
				holding={transactionsHolding}
				onClose={() => setTransactionsHolding(null)}
			/>
		</>
	);
};
